import { ChatResponder } from "@redotech/redo-model/agents/chat-history";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const getAiChats = {
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    chatHistory: z
      .object({
        responder: z.nativeEnum(ChatResponder),
        message: z.string(),
        createdAt: z.date(),
      })
      .array(),
  }),
};
